import React, { useState } from 'react';
// @ts-ignore
import styles from './MedicalReportsList.module.scss';
// @ts-ignore
import moment, { Moment } from 'moment';
import Button from '../Button/Button';
import { Theme } from '../../Enums/Theme.enum';
import { useAppContext } from '../../Services/AppContext';
import MediaViewerModal from '../MediaViewer/MediaViewerModal';
import AntivirusCheck from '../Base/Loading/AntivirusCheck';
import FormattedMomentDate, {
	DateFormat,
} from '../../Modules/Base/Components/FormattedMomentDate/FormattedMomentDate';

interface MedicalReportsListProps {
	item: {
		id: string;
		createdAt: string;
		title: {
			extra: {
				text: string;
			};
		};
		file: {
			avResultText: string;
		};
	};
	key: string;
}

export default function MedicalReportsListItem(props: MedicalReportsListProps) {
	const { item } = props;
	const [mediaViewerOpened, setMediaViewerOpened] = useState(false);
	const { translation, socketUrl } = useAppContext();

	const fileToViewer = {
		id: item.id,
		name: item.title?.extra?.text,
		displayName: item.title?.extra?.text,
		type: 'pdf',
		preview: socketUrl + '/document/' + item.id + '/pdf/download',
		download: socketUrl + '/document/' + item.id + '/pdf/download',
	};

	return (
		<div className={styles.item}>
			<div className={styles.date}>
				<FormattedMomentDate
					date={item.createdAt}
					format={DateFormat.DATE_TIME}
				/>
			</div>
			<div className={styles.title}>{item.title?.extra?.text}</div>
			<div className={styles.controls}>
				{item?.file?.avResultText === 'clean' ? (
					<Button
						onClick={() => setMediaViewerOpened(true)}
						title={translation['base.detail']}
						theme={Theme.GREEN}
					/>
				) : (
					<div>
						<AntivirusCheck inRow={true} />
					</div>
				)}
			</div>
			<MediaViewerModal
				opened={mediaViewerOpened}
				onClose={() => setMediaViewerOpened(false)}
				file={fileToViewer}
			/>
		</div>
	);
}
